import React, { useEffect,useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import Loader from '../../../components/Loader';
import { Divider, FormControlLabel, Grid, Radio, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import { useFormik } from 'formik';
import * as yup from "yup";
import SelectInput from '../../../components/SelectInput';
import CommonButtonVoucherForm from '../../../shared-components/common-button/CommonButtonVoucherForm';
import {
    setActiveStep, setApplicantActiveStep, setEditPreviewApplicant, setReviewActiveStep,
    setStepsCompleted,
    updateApplicantDetailsForm,
} from "../voucher-form.slice";
import { route } from '../../../services/apiRoutes';
import { EOI_TABLE_DATA, FLOOR_OPTIONS, formatIndianCurrencyShort, SERIES_OPTIONS, TOWER_OPTIONS, UNIT_OPTIONS } from '../../../config/constant';


const EoiUnitPreference = () => {
    const dispatch = useDispatch();
    const { voucherId } = useParams();

    const { applicantData, activeStep, isLoading, stepsCompleted,eoiCampaignDetails } = useSelector(
        (state) => state?.voucherForm
        
    );
    const unitPreferenceFormik = useFormik({
        initialValues: {
            typologyPreference: "",
            eoiPreference: "",
            facingDirection : "",
            // tower1: "",
            // floor1: "",
            // series1: "",
            // unit1: "",
            // tower2: "",
            // floor2: "",
            // series2: "",
            // unit2: "",
            // tower3: "",
            // floor3: "",
            // series3: "",
            // unit3: "",
        },
        validationSchema: yup.object().shape({
            typologyPreference: yup.string().required("Unit Preference is required"),
            eoiPreference: yup.string().required("EOI Preference is required"),
            facingDirection: yup.string().required("Unit Facing Direction is required"),
            // tower1: yup.string().when("eoiPreference", (ll, schema) => {
            //     return unitPreferenceFormik.values.eoiPreference === "Preferential"
            //         ? yup
            //             .string()
            //             .required("Tower is required")
            //         : yup.array().notRequired();
            // }),
            // floor1: yup.string().when("eoiPreference", (ll, schema) => {
            //     return unitPreferenceFormik.values.eoiPreference === "Preferential"
            //         ? yup
            //             .string()
            //             .required("Floor is required")
            //         : yup.array().notRequired();
            // }),
            // series1: yup.string().when("eoiPreference", (ll, schema) => {
            //     return unitPreferenceFormik.values.eoiPreference === "Preferential"
            //         ? yup
            //             .string()
            //             .required("Series is required")
            //         : yup.array().notRequired();
            // }),
            // unit1: yup.string().when("eoiPreference", (ll, schema) => {
            //     return unitPreferenceFormik.values.eoiPreference === "Preferential"
            //         ? yup
            //             .string()
            //             .required("Unit is required")
            //         : yup.array().notRequired();
            // }),
            // tower2: yup.string().when("eoiPreference", (ll, schema) => {
            //     return unitPreferenceFormik.values.eoiPreference === "Preferential"
            //         ? yup
            //             .string()
            //             .required("Tower is required")
            //         : yup.array().notRequired();
            // }),
            // floor2: yup.string().when("eoiPreference", (ll, schema) => {
            //     return unitPreferenceFormik.values.eoiPreference === "Preferential"
            //         ? yup
            //             .string()
            //             .required("Floor is required")
            //         : yup.array().notRequired();
            // }),
            // series2: yup.string().when("eoiPreference", (ll, schema) => {
            //     return unitPreferenceFormik.values.eoiPreference === "Preferential"
            //         ? yup
            //             .string()
            //             .required("Series is required")
            //         : yup.array().notRequired();
            // }),
            // unit2: yup.string().when("eoiPreference", (ll, schema) => {
            //     return unitPreferenceFormik.values.eoiPreference === "Preferential"
            //         ? yup
            //             .string()
            //             .required("Unit is required")
            //         : yup.array().notRequired();
            // }),
            // tower3: yup.string().when("eoiPreference", (ll, schema) => {
            //     return unitPreferenceFormik.values.eoiPreference === "Preferential"
            //         ? yup
            //             .string()
            //             .required("Tower is required")
            //         : yup.array().notRequired();
            // }),
            // floor3: yup.string().when("eoiPreference", (ll, schema) => {
            //     return unitPreferenceFormik.values.eoiPreference === "Preferential"
            //         ? yup
            //             .string()
            //             .required("Floor is required")
            //         : yup.array().notRequired();
            // }),
            // series3: yup.string().when("eoiPreference", (ll, schema) => {
            //     return unitPreferenceFormik.values.eoiPreference === "Preferential"
            //         ? yup
            //             .string()
            //             .required("Series is required")
            //         : yup.array().notRequired();
            // }),
            // unit3: yup.string().when("eoiPreference", (ll, schema) => {
            //     return unitPreferenceFormik.values.eoiPreference === "Preferential"
            //         ? yup
            //             .string()
            //             .required("Unit is required")
            //         : yup.array().notRequired();
            // }),
        }),
    });

    useEffect(() => {
        if (applicantData?.eoiDetails) {
            const { eoiDetails } = applicantData;

            unitPreferenceFormik.setValues({
                typologyPreference: eoiDetails?.typology || "",
                eoiPreference: eoiDetails?.eoiType || "",
                facingDirection : eoiDetails?.facingDirection ||"",
                // // Preference 1
                // tower1: eoiDetails?.preferences?.[0]?.tower || "",
                // floor1: eoiDetails?.preferences?.[0]?.floor || "",
                // series1: eoiDetails?.preferences?.[0]?.series || "",
                // unit1: eoiDetails?.preferences?.[0]?.unit || "",

                // // Preference 2
                // tower2: eoiDetails?.preferences?.[1]?.tower || "",
                // floor2: eoiDetails?.preferences?.[1]?.floor || "",
                // series2: eoiDetails?.preferences?.[1]?.series || "",
                // unit2: eoiDetails?.preferences?.[1]?.unit || "",

                // // Preference 3
                // tower3: eoiDetails?.preferences?.[2]?.tower || "",
                // floor3: eoiDetails?.preferences?.[2]?.floor || "",
                // series3: eoiDetails?.preferences?.[2]?.series || "",
                // unit3: eoiDetails?.preferences?.[2]?.unit || "",
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [applicantData, applicantData?.eoiDetails]);

    useEffect(() => {
        unitPreferenceFormik.validateForm()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [unitPreferenceFormik?.values])

    const handlePrevious = () => {
        dispatch(setActiveStep(activeStep - 1))
    }

    // Helper function to create the other details payload
    const createUnitPreferencePayload = (saveForLaterFlag = false) => {
        const { values } = unitPreferenceFormik;
        const payload = {
            saveForLater: saveForLaterFlag,
            typology: values?.typologyPreference || "",
            eoiType: values?.eoiPreference || "",
            facingDirection: values?.facingDirection || "",
        };
        // if (values?.eoiPreference === "Preferential") {
        //     payload.preferences = [
        //         {
        //             tower: values?.tower1 || "",
        //             floor: values?.floor1 || "",
        //             series: values?.series1 || "",
        //             unit: values?.unit1 || "",
        //         },
        //         {
        //             tower: values?.tower2 || "",
        //             floor: values?.floor2 || "",
        //             series: values?.series2 || "",
        //             unit: values?.unit2 || "",
        //         },
        //         {
        //             tower: values?.tower3 || "",
        //             floor: values?.floor3 || "",
        //             series: values?.series3 || "",
        //             unit: values?.unit3 || "",
        //         },
        //     ];
        // }
        return payload;
    };

    const handleSaveForm = (type) => {
        if (Object.keys(unitPreferenceFormik.errors).length === 0) {
            const payload = {
                ...createUnitPreferencePayload(type === "saveForLater"),
                lastStep:activeStep+1,
            };
            dispatch(setReviewActiveStep(0));
            dispatch(
                updateApplicantDetailsForm({
                    path: `${route.UPDATE_EOI_DETAILS}/${voucherId}`,
                    payload: payload,
                    opportunityId: voucherId
                })
            )
                .unwrap()
                .then((res) => {
                    if (res?.status === 200) {
                        let completedSteps = {
                            ...stepsCompleted,
                            [activeStep]: true,
                        };
                        dispatch(setEditPreviewApplicant(false));
                        dispatch(setStepsCompleted(completedSteps));
                        dispatch(setApplicantActiveStep(0));
                        dispatch(setActiveStep(activeStep + 1));
                    }
                }
                );
        }
    };

  const usePlotsUnitTableData = () => {

  const PLOTS_UNIT_TABLE_DATA = useMemo(() => {
    const inventory = eoiCampaignDetails?.inventoryDetails || [];

    const tableData = inventory?.map((item) => {
      const { type, minSBA, maxSBA, minPrice, maxPrice } = item;

      return {
        typology: type || '',
        area: `${minSBA ? minSBA : 0} - ${maxSBA ? maxSBA : 0} Sq.ft.`,
        price: `${minPrice ? formatIndianCurrencyShort(minPrice) : 0} - ${maxPrice ? formatIndianCurrencyShort(maxPrice) : 0}`,
        value: type || '',
      };
    });

    // Optional static entry for facing directions
    tableData?.push({
      typology: "Unit Facing Directions",
      directions: [
        "North",
        "South",
        "East",
        "West",
        "Northwest",
        "Southwest",
        "Northeast",
        "Southeast",
      ],
      value: "facingDirection",
    });

    return tableData;
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [eoiCampaignDetails]);

  return PLOTS_UNIT_TABLE_DATA;
};
const EOI_TABLE_DATA = [
  eoiCampaignDetails?.stdEoiAmount &&{
    eoi: "Standard",
    amount: `₹${
      eoiCampaignDetails?.stdEoiAmount
        ? formatIndianCurrencyShort(eoiCampaignDetails?.stdEoiAmount)
        : 0
    } (EOI Value)`,
    advantage: "Unit Select based on availability",
  },
  eoiCampaignDetails?.preEoiAmount && {
    eoi: "Preferential",
    amount: `₹${
      formatIndianCurrencyShort(eoiCampaignDetails?.preEoiAmount || 0)
    } (EOI Value)`,
    advantage: "1st Preference & Spot Allocation",
  },
]?.filter(Boolean);


    return (
        <div>
            {isLoading && <Loader isLoading={isLoading} />}
            <Typography
                sx={{
                    color: "#1C252E",
                    fontSize: "16px",
                    fontWeight: "600",
                    lineHeight: "36px",
                    mb: "12px",
                    textAlign: "center",
                }}
            >
                Unit Preference
            </Typography>

            <form
                onSubmit={unitPreferenceFormik.handleSubmit}
                onReset={unitPreferenceFormik.handleReset}
            >
                <TableContainer sx={{ overflowX: "auto" }}>
                    <Table
                        sx={{
                            '& td, & th': {
                                border: '1px solid #E0E0E0',
                            },
                        }}>
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{ width: '17%' }}>
                                    <Typography sx={{ fontSize: '14px', fontWeight: 500 }}>
                                        My/ Our Preference
                                    </Typography>
                                </TableCell>
                                <TableCell sx={{ width: '26%' }}>
                                    <Typography  sx={{ fontSize: '14px', fontWeight: 500 }}>
                                        Typology
                                    </Typography>
                                </TableCell>
                                <TableCell colSpan={2} sx={{ width: '26%' }}>
                                    <Typography sx={{ fontSize: '14px', fontWeight: 500 }}>
                                        Indicative Saleable Area
                                    </Typography>
                                </TableCell>
                                <TableCell colSpan={2} sx={{ width: '26%' }}>
                                    <Typography sx={{ fontSize: '14px', fontWeight: 500 }}>
                                        Indicative Unit Price
                                    </Typography>
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {(usePlotsUnitTableData() ?? [])?.map((row, index) => {
                                // handle rows with directions
                                if (row.directions) {
                                    // split directions into 2 arrays of 4 each
                                    const firstRowDirections = row.directions.slice(0, 4);
                                    const secondRowDirections = row.directions.slice(4);

                                    return (
                                        <>
                                            {/* First row */}
                                            <TableRow key={`${row.value}-row-1`}>
                                                {/* Typology cell only on the first row */}
                                                <TableCell colSpan={2} rowSpan={2} sx={{ fontSize: '12px', fontWeight: 500, textAlign: 'center' }}>
                                                    {row.typology}
                                                </TableCell>

                                                {firstRowDirections.map((dir) => (
                                                    <TableCell key={dir}>
                                                        <FormControlLabel
                                                            value={dir}
                                                            control={
                                                                <Radio
                                                                    size="small"
                                                                    name="facingDirection"
                                                                    checked={unitPreferenceFormik.values.facingDirection === dir}
                                                                    onChange={() =>
                                                                        unitPreferenceFormik.setFieldValue("facingDirection", dir)
                                                                    }
                                                                    sx={{my:0, py:0}}
                                                                />
                                                            }
                                                            label={dir}
                                                            sx={{
                                                                '.MuiFormControlLabel-label': {
                                                                    fontSize: '12px',
                                                                    fontWeight: 500,
                                                                },
                                                            }}
                                                        />
                                                    </TableCell>
                                                ))}
                                            </TableRow>

                                            {/* Second row */}
                                            <TableRow key={`${row.value}-row-2`}>
                                                {secondRowDirections.map((dir) => (
                                                    <TableCell key={dir}>
                                                        <FormControlLabel
                                                            value={dir}
                                                            control={
                                                                <Radio
                                                                    size="small"
                                                                    name="facingDirection"
                                                                    checked={unitPreferenceFormik.values.facingDirection === dir}
                                                                    onChange={() =>
                                                                        unitPreferenceFormik.setFieldValue("facingDirection", dir)
                                                                    }
                                                                    sx={{my:0, py:0}}
                                                                />
                                                            }
                                                            label={dir}
                                                            sx={{
                                                                '.MuiFormControlLabel-label': {
                                                                    fontSize: '12px',
                                                                    fontWeight: 500,
                                                                },
                                                            }}
                                                        />
                                                    </TableCell>
                                                ))}
                                            </TableRow>
                                        </>
                                    );
                                }


                                // handle normal rows
                                return (
                                    <TableRow key={index}>
                                        <TableCell sx={{ padding: '7px', textAlign: 'center' }}>
                                            <Radio
                                                checked={unitPreferenceFormik.values.typologyPreference === row.value}
                                                onChange={() =>
                                                    unitPreferenceFormik.setFieldValue("typologyPreference", row.value)
                                                }
                                                value={row.value}
                                            />
                                        </TableCell>
                                        <TableCell  sx={{ fontSize: '12px', fontWeight: 500 }}>{row.typology}</TableCell>
                                        <TableCell colSpan={2} sx={{ fontSize: '12px', fontWeight: 500 }}>{row.area}</TableCell>
                                        <TableCell colSpan={2} sx={{ fontSize: '12px', fontWeight: 500 }}>   {row.price?.includes('-') ? `₹${row.price.replace(/\s*-\s*/, ' – ₹')}` : `₹${row.price}`}</TableCell>
                                    </TableRow>
                                );
                            })}


                            <TableRow>
                                <TableCell
                                    colSpan={9}
                                    sx={{ textAlign: "center", fontWeight: 500, fontSize: "12px" }}
                                >
                                    Indicative Base Price-₹{eoiCampaignDetails?.indicativeBasePrice} per Sq. ft
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                    {unitPreferenceFormik.touched.typologyPreference && unitPreferenceFormik.errors.typologyPreference && (
                        <Typography sx={{ color: "red", fontSize: "12px", mt: 1 }}>
                            {unitPreferenceFormik.errors.typologyPreference}
                        </Typography>
                    )}
                    {unitPreferenceFormik.touched.facingDirection && unitPreferenceFormik.errors.facingDirection && (
                        <Typography sx={{ color: "red", fontSize: "12px", mt: 1 }}>
                            {unitPreferenceFormik.errors.facingDirection}
                        </Typography>
                    )}
                </TableContainer>

                <Typography mt={3} sx={{ fontSize: '14px', color: '#1C252E', lineHeight: '22px' }}>
                    Price range indicated here does not include charges (if any) of Floor Rise Charges of ₹ 25
                    per Sq.Ft. per floor, Premium Charges of ₹ 0 per Sq.Ft. to ₹ 300 per Sq.Ft., Clubhouse Charges
                    of ₹ 3,00,000, Car Parking Charges of ₹ 3,00,000, Infra charges of ₹ 350 per Sq.Ft., Legal fees
                    of ₹ 60,000 & Advance Maintenance Charges of ₹ 5 per Sq.Ft. for 12 months.
                </Typography>
                <Typography sx={{ fontSize: '14px', color: '#1C252E', lineHeight: '22px' }}>
                    Price range mentioned above does not include units with Private Terrace/Garden space. Additional
                    charges will apply for the same.
                </Typography>
                <Typography mb={3} sx={{ fontSize: '14px', color: '#1C252E', lineHeight: '22px' }}>
                    Additionally, all statutory charges e.g. registration charges, stamp duty, GST, municipal taxes
                    etc. are not included and shall be payable at actuals as may be applicable from time to time.
                </Typography>

                <TableContainer sx={{ overflowX: "auto", mb: 3 }}>
                    <Table
                        sx={{
                            '& td, & th': {
                                border: '1px solid #E0E0E0',
                            },
                        }}>
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{ width: "17%" }}>
                                    <Typography sx={{ fontSize: '14px', fontWeight: 500 }}>
                                        My/ Our Preference
                                    </Typography>
                                </TableCell>
                                <TableCell sx={{ width: "26%" }}>
                                    <Typography sx={{ fontSize: '14px', fontWeight: 500 }}>
                                        EOI
                                    </Typography>
                                </TableCell>
                                <TableCell sx={{ width: "26%" }}>
                                    <Typography sx={{ fontSize: '14px', fontWeight: 500 }}>
                                        Amount
                                    </Typography>
                                </TableCell>
                                <TableCell sx={{ width: "26%" }}>
                                    <Typography sx={{ fontSize: '14px', fontWeight: 500 }}>
                                        Advantage
                                    </Typography>
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {EOI_TABLE_DATA.map((row, index) => (
                                <TableRow key={index}>
                                    <TableCell sx={{ padding: '7px', textAlign: "center" }}>
                                        <Radio
                                            checked={unitPreferenceFormik.values.eoiPreference === row.eoi}
                                            onChange={() => unitPreferenceFormik.setFieldValue("eoiPreference", row.eoi)}
                                            value={row.eoi}
                                        />
                                    </TableCell>
                                    <TableCell sx={{ fontSize: '12px', fontWeight: 500 }}>{row.eoi}</TableCell>
                                    <TableCell sx={{ fontSize: '12px', fontWeight: 500 }}>{row.amount}</TableCell>
                                    <TableCell sx={{ fontSize: '12px', fontWeight: 500 }}>{row.advantage}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                    {unitPreferenceFormik.touched.eoiPreference && unitPreferenceFormik.errors.eoiPreference && (
                        <Typography sx={{ color: "red", fontSize: "12px", mt: 1 }}>
                            {unitPreferenceFormik.errors.eoiPreference}
                        </Typography>
                    )}
                </TableContainer>

                {/* {unitPreferenceFormik.values.eoiPreference === "Preferential" && (
                    <>
                        <Typography sx={{ fontSize: '14px', fontWeight: 600 }}>Select Preference 1</Typography>
                        <Grid container spacing={2} mt={0}>
                            <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                                <SelectInput
                                    field={{
                                        name: "tower1",
                                        label: "Tower",
                                        required: true,
                                        readonly: false,
                                        options: TOWER_OPTIONS,
                                        placeholder: "Select Tower"
                                    }}
                                    formik={unitPreferenceFormik}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                                <SelectInput
                                    field={{
                                        name: "floor1",
                                        label: "Floor",
                                        required: true,
                                        readonly: false,
                                        options: FLOOR_OPTIONS,
                                        placeholder: "Select Floor"
                                    }}
                                    formik={unitPreferenceFormik}
                                />
                            </Grid>
                        </Grid>
                        <Grid container spacing={2} mt={0}>
                            <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                                <SelectInput
                                    field={{
                                        name: "series1",
                                        label: "Series",
                                        required: true,
                                        readonly: false,
                                        options: SERIES_OPTIONS,
                                        placeholder: "Select Series"
                                    }}
                                    formik={unitPreferenceFormik}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                                <SelectInput
                                    field={{
                                        name: "unit1",
                                        label: "Unit",
                                        required: true,
                                        readonly: false,
                                        options: UNIT_OPTIONS,
                                        placeholder: "Select Unit"
                                    }}
                                    formik={unitPreferenceFormik}
                                />
                            </Grid>
                        </Grid>
                        <Divider sx={{ mt: 2, border: '1px dashed #DADADA' }} />

                        <Typography mt={2} sx={{ fontSize: '14px', fontWeight: 600 }}>Select Preference 2</Typography>
                        <Grid container spacing={2} mt={0}>
                            <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                                <SelectInput
                                    field={{
                                        name: "tower2",
                                        label: "Tower",
                                        required: true,
                                        readonly: false,
                                        options: TOWER_OPTIONS,
                                        placeholder: "Select Tower"
                                    }}
                                    formik={unitPreferenceFormik}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                                <SelectInput
                                    field={{
                                        name: "floor2",
                                        label: "Floor",
                                        required: true,
                                        readonly: false,
                                        options: FLOOR_OPTIONS,
                                        placeholder: "Select Floor"
                                    }}
                                    formik={unitPreferenceFormik}
                                />
                            </Grid>
                        </Grid>
                        <Grid container spacing={2} mt={0}>
                            <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                                <SelectInput
                                    field={{
                                        name: "series2",
                                        label: "Series",
                                        required: true,
                                        readonly: false,
                                        options: SERIES_OPTIONS,
                                        placeholder: "Select Series"
                                    }}
                                    formik={unitPreferenceFormik}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                                <SelectInput
                                    field={{
                                        name: "unit2",
                                        label: "Unit",
                                        required: true,
                                        readonly: false,
                                        options: UNIT_OPTIONS,
                                        placeholder: "Select Unit"
                                    }}
                                    formik={unitPreferenceFormik}
                                />
                            </Grid>
                        </Grid>
                        <Divider sx={{ mt: 2, border: '1px dashed #DADADA' }} />

                        <Typography mt={2} sx={{ fontSize: '14px', fontWeight: 600 }}>Select Preference 3</Typography>
                        <Grid container spacing={2} mt={0}>
                            <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                                <SelectInput
                                    field={{
                                        name: "tower3",
                                        label: "Tower",
                                        required: true,
                                        readonly: false,
                                        options: TOWER_OPTIONS,
                                        placeholder: "Select Tower"
                                    }}
                                    formik={unitPreferenceFormik}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                                <SelectInput
                                    field={{
                                        name: "floor3",
                                        label: "Floor",
                                        required: true,
                                        readonly: false,
                                        options: FLOOR_OPTIONS,
                                        placeholder: "Select Floor"
                                    }}
                                    formik={unitPreferenceFormik}
                                />
                            </Grid>
                        </Grid>
                        <Grid container spacing={2} mt={0}>
                            <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                                <SelectInput
                                    field={{
                                        name: "series3",
                                        label: "Series",
                                        required: true,
                                        readonly: false,
                                        options: SERIES_OPTIONS,
                                        placeholder: "Select Series"
                                    }}
                                    formik={unitPreferenceFormik}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                                <SelectInput
                                    field={{
                                        name: "unit3",
                                        label: "Unit",
                                        required: true,
                                        readonly: false,
                                        options: UNIT_OPTIONS,
                                        placeholder: "Select Unit"
                                    }}
                                    formik={unitPreferenceFormik}
                                />
                            </Grid>
                        </Grid>
                        <Divider sx={{ mt: 2, border: '1px dashed #DADADA' }} />
                    </>
                )} */}

                <CommonButtonVoucherForm
                    handleNext={handleSaveForm}
                    // isDisable={isDisable}
                    handlePrevious={handlePrevious}
                    saveDraftPath={`${route.UPDATE_EOI_DETAILS}/${voucherId}`}
                    saveDraftData={{
                        ...createUnitPreferencePayload(true),
                        lastStep: applicantData?.lastStep > activeStep
                            ? applicantData?.lastStep
                            : activeStep,
                    }}
                />
            </form>
        </div>
    )
}

export default EoiUnitPreference